import React, { useState } from "react"
import { useLocation } from "react-router-dom"
import CommonTitle from "components/common/CommonTitle"
import Layout from "components/Layout/Layout"
import { Box } from "@mui/material"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"
import styles from "./Finished.module.scss"

const GoToSaficSiteButton = () => {
  return (
    <a className={styles.button} href="https://www.sompo-direct.co.jp/otona/?cid=WHP001">
      <span>ＳＯＭＰＯダイレクトTOPへ</span>
      <div>
        <ArrowForwardIcon style={{ color: "#666666" }} />
      </div>
    </a>
  )
}

export interface Props {
  adress: any
}
/**
 * Step5 見積完了画面
 */
const Finished = (props: any) => {
  const location = useLocation()
  const mailAdress = location.state

  return (
    <Layout>
      <Box className={styles.nonStepBarWrap}>
        <CommonTitle titles={["ご利用ありがとうございました"]} read="" />
        <div className={styles.tagLine}>
          <span>お見積りをマイページに保存しました。</span>
        </div>
        <Box className={styles.textWrapper}>
          マイページのご利用案内は、ご入力のメールアドレス（
          <span style={{ fontWeight: 500 }}>{mailAdress}</span>
          ）に送付しました。
          <p>
            詳細なお見積りは、当社マイページから可能です。
            <br />
            是非ともメール記載のURLからマイページにログインのうえ、お見積りとお申込みのご検討のほどよろしくお願いします。
          </p>
        </Box>
      </Box>
      <GoToSaficSiteButton />
    </Layout>
  )
}

export default Finished
